import { Form, Grid, TextField } from '@approvalmax/ui/src/components';
import { domHelpers } from '@approvalmax/utils';
import { constants } from 'modules/common';
import { FC } from 'react';

import { messages } from './BatchPaymentSection.messages';
import type { BatchPaymentSectionProps } from './BatchPaymentSection.types';

export const BatchPaymentSection: FC<BatchPaymentSectionProps> = (props) => {
    const { qa, isUKCompany } = props;

    return (
        <Form.Part>
            <Grid gridTemplateColumns='1fr 1fr' gap={16}>
                {isUKCompany && (
                    <TextField
                        name='bankAccount.sortCode'
                        qa={domHelpers.generateDataQa(qa, 'sort-code')}
                        label={messages.sortCodeLabel}
                        placeholder={messages.sortCodePlaceholder}
                        maxLength={constants.xeroConstants.sortCodeMaxLength}
                    />
                )}

                <TextField
                    name='bankAccount.bankAccountDetails'
                    qa={domHelpers.generateDataQa(qa, 'bank-account-number')}
                    label={messages.bankAccountNumberLabel}
                    placeholder={messages.bankAccountNumberPlaceholder}
                    maxLength={constants.xeroConstants.BANK_ACCOUNT_DETAILS_MAX_LENGTH}
                />
            </Grid>
        </Form.Part>
    );
};

BatchPaymentSection.displayName = 'BatchPaymentSection';
